import {ElasticCatalogService,ElasticCatalogPager} from '../../../../services/ElasticCatalogService';
import {Component, Injector, OnInit} from '@angular/core';
import {Framework} from "../../../../domain/frameworks/Framework";
import {FrameworkService} from "../../../../services/FrameworkService";
import {RoleService} from "../../../../services/common/RoleService";
import {PermissionType} from "../../../../domain/user/Permission";
import {Localization} from "../../../../data/Localization";
import {BaseComponent} from "../../../BaseComponent";


@Component({
	selector: 'list-frameworks',
	templateUrl: './list-frameworks.component.html',
	styleUrls: ['./list-frameworks.component.scss']
})
export class ListFrameworksComponent extends BaseComponent implements OnInit {

    public elasticPage:ElasticCatalogPager<any>;
    public currentSearchValue='';
    public setSearchValue(value:string):void {this.currentSearchValue=value;this.elasticPage?.refresh({text:value});this.navHistoryService.saveState({filter:value});}

	private cbContext = Localization.template.frameworks.list;
	public CB = {
		header: this.cbContext.header,
		create: this.cbContext.create,
		edit: this.cbContext.edit,
		view: this.cbContext.view,
	};

	public frameworks:Framework[] = [];

	constructor(private frameworkService:FrameworkService,
				protected injector:Injector) {
		super(injector);
		this.localizationService.registerAndLocalize("ListFrameworksComponent", this.CB);

		this.logger.info("list-frameworks.component [constructor]");
        const elastic=this.injector.get(ElasticCatalogService);
        if(elastic.enabled) {
            this.elasticPage=elastic.session('frameworks',items=>this.frameworks=items);
            this.trackSubscription(this.elasticPage);
            this.trackSubscription(this.authService.currentUser$.subscribe(()=>this.elasticPage.refresh({text:this.currentSearchValue},true)));
            this.trackSubscription(this.navHistoryService.restoredState$.subscribe(state=>{
                if(document.location.toString()===state?.url) {this.currentSearchValue=state.savedState?.filter || '';this.elasticPage.refresh({text:this.currentSearchValue});}
            }));
            this.elasticPage.refresh({text:this.currentSearchValue});
        } else {
            this.frameworkService.list.frameworks.relativeVisibility.full$().subscribe(frameworks => {
                this.frameworks = frameworks;
            });
        }
	}

	ngOnInit() {

	}

	public saveStateAndNavigate(selectedId:string, navCommands:any[]) {
		this.navHistoryService.saveStateAndNavigate({selectedId: selectedId,filter:this.currentSearchValue}, navCommands);
	}

	public role():RoleService {
		return this.roleService;
	}

	public canCreateFramework():boolean {
		return this.roleService.hasPermissionFor(PermissionType.create_framework);
	}

	public canEditFramework(orgGuid:string):boolean {
		return this.roleService.hasPermissionFor(PermissionType.edit_framework, orgGuid);
	}
}
